var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M11 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 7a5 5 0 0 0 0 10h8a5 5 0 0 0 0-10H8zm-7 5a7 7 0 0 1 7-7h8a7 7 0 1 1 0 14H8a7 7 0 0 1-7-7z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }